import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Thoughts from './pages/Thoughts';
import ExcellentOperators from './pages/ExcellentOperators';

function Navigation() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <nav className="top-nav">
      <div className="nav-container">
        {isHome ? (
          <Link to="/thoughts" className="nav-link">thoughts</Link>
        ) : (
          <Link to="/" className="nav-link">home</Link>
        )}
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thoughts" element={<Thoughts />} />
          <Route path="/excellent-operators" element={<ExcellentOperators />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
